<app-reactive-select-input
  *ngIf="abstractControls.category$ | async as categoryObserver"
  [isInline]="isInline"
  [filedLabel]="categoryObserver?.title"
  [fieldId]="'inputGroupCategory'"
  [control]="control"
  [keyOptions]="keyValueOptions"
>
</app-reactive-select-input>
